import client, { simpleClient } from './apollo-client'

export const resetStore = () => {
    client.resetStore();
    simpleClient.resetStore();
}